import { BabyWrappedIcon } from '@navikt/aksel-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { HvemPlanlegger, HvemPlanleggerType } from 'types/HvemPlanlegger';
import { finnSøker2Tekst } from 'utils/HvemPlanleggerUtils';

import { BodyLong, HStack, Heading } from '@navikt/ds-react';

import { IconCircleWrapper } from '@navikt/fp-ui';

interface Props {
    hvemPlanlegger: HvemPlanlegger;
}

export const ToUkerRundtFødsel = ({ hvemPlanlegger }: Props) => {
    const intl = useIntl();
    return (
        <HStack gap="space-20" wrap={false}>
            <div>
                <IconCircleWrapper color="lightBlue" size="medium">
                    <BabyWrappedIcon
                        height={22}
                        width={22}
                        fontSize="1.5rem"
                        color="var(--ax-bg-accent-strong)"
                        aria-hidden
                    />
                </IconCircleWrapper>
            </div>
            <div>
                <Heading size="small" level="4">
                    <FormattedMessage id="HvaErMulig.ToUkerRundtFødsel" />
                </Heading>
                <BodyLong>
                    {hvemPlanlegger.type !== HvemPlanleggerType.FAR_OG_FAR ? (
                        <FormattedMessage
                            id="HvaErMulig.ToUkerRundtFødsel.Tekst"
                            values={{
                                hvem: finnSøker2Tekst(intl, hvemPlanlegger),
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id="HvaErMulig.ToUkerRundtFødsel.FedreTekst"
                            values={{
                                hvem: finnSøker2Tekst(intl, hvemPlanlegger),
                            }}
                        />
                    )}
                </BodyLong>
            </div>
        </HStack>
    );
};
